import { SearchHeader } from "@/components/products/search";
import { ProductGrid } from "@/components/products/product-grid";
import { Filters, Product } from "@/types";
import { Pagination, PaginationData } from "@/components/pagination";
import { router } from "@inertiajs/react";
import Sorting from "@/components/sorting";

interface ProductsPageProps {
  products: Product[];
  filters: Filters;
  pagination: PaginationData;
  vendors: string[];
  colors: string[];
}

export default function ProductsPage({
  products,
  filters,
  pagination,
  vendors,
  colors,
}: ProductsPageProps) {
  console.log("products ", products);
  console.log("filters", filters);
  console.log("pagination ", pagination);
  console.log("vendors", vendors);
  console.log("colors", colors);
  return (
    <main className="min-h-screen">
      <SearchHeader filters={filters} vendors={vendors} colors={colors} />
      <Sorting sortType={filters.sort} onSortingType={(sort) => {
        router.visit(
          "/products",
          {
            data: {
              search: filters.search, vendors: filters.vendors, colors: filters.colors, page: pagination.page, sort: sort,
            }
          },
        );
      }} />
      <ProductGrid products={products} />
      <Pagination filters={filters} data={pagination} onPageChange={(page) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        router.visit(
          "/products",
          {
            data: {
              search: filters.search, vendors: filters.vendors, colors: filters.colors, page: page, sort: filters.sort
            }
          },
        );
      }
      } />
    </main>
  );
}
